import { render, staticRenderFns } from "./BenefitShow.vue?vue&type=template&id=377836c6&scoped=true"
import script from "./BenefitShow.vue?vue&type=script&lang=js"
export * from "./BenefitShow.vue?vue&type=script&lang=js"
import style0 from "./BenefitShow.vue?vue&type=style&index=0&id=377836c6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377836c6",
  null
  
)

export default component.exports